import { useAccessControl } from "@/hooks/useAccessControl";
import { useMarketsClosedStatus } from "@/hooks/useMarketsClosedStatus";

export const MarketsClosedBanner = () => {
  const { authenticated } = useAccessControl();
  const { isMarketsClosed, localizedReopenTime } = useMarketsClosedStatus();

  if (!authenticated || !isMarketsClosed) return null;

  return (
    <div className="hidden sm:flex items-center justify-center gap-3 bg-gray-900 border-b border-gray-800 py-2.5 px-4">
      <div className="flex items-center gap-2">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-terminal-orange opacity-60" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-terminal-orange" />
        </span>
        <span className="text-xs font-semibold text-terminal-orange uppercase">
          Markets Closed
        </span>
      </div>
      <span className="text-xs text-gray-500">&mdash;</span>
      <span className="text-xs text-gray-400">
        Live service resumes with Asia open at{" "}
        <span className="text-terminal-orange">{localizedReopenTime}</span>
      </span>
    </div>
  );
};
